module.exports = __webpack_public_path__ + "media/packs/images/flags/GR-e6e5efa14d0c78b09ff9d5d7f262ecba.svg";